import {currentUserMeetsUserLevel} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {SEARCH_CONSTITIUENT_CLIPS_MINIMUM_USER_LEVEL} from '../constants';

export const consituentClipsEnabled = () =>
	currentUserMeetsUserLevel(SEARCH_CONSTITIUENT_CLIPS_MINIMUM_USER_LEVEL);
